import React, { useState } from 'react';
import {
  Input,
  Label,
  RadioGroup,
  RadioButton,
  Select,
  SelectOption,
} from '@americanexpress/dls-react';
import AttachFiles from '../Util/AttachFiles';
import {
  validateInputs,
  validateField,
} from '../../validators/vendorIntakeFormValidator';
import MousePopover from '../Util/UIComp/MouseHover';
import * as LABELCONST from '../../constants/constFileLabelsVendor';
import * as stringConstants from '../../constants/stringConstants';
import {
  isTaxFieldVisible,
  isPaymentMethodCPCOrBIP,
  isBillingCountryUSA,
  isBillingCountryAndCountryFrance,
} from '../../helper/utilityMethods';

const SupplierOtherInfo = (props) => {
  const { setFormErrors, setFormData, formData, formErrors } = props;
  const [showOtherPaymentMethodInput, setShowOtherPaymentMethodInput] =
    useState(false);
  const [otherPaymentMethod, setotherPaymentMethod] = useState('');

  const toggleOtherPaymentMethod = () => {
    setShowOtherPaymentMethodInput(!showOtherPaymentMethodInput);
  };

  const taxIdNumber = isBillingCountryUSA(formData.billingCountry?.CountryName?.toLowerCase() ?? '')
    ? {
      taxIdNoText: 'TIN /SSN /Federal Tax #',
      taxIdNoPopUpValue: 'Provide the Tax identification Number (TIN) '
        + '/ Social Security Number (SSN) / Federal Tax Number used for tax purposes in the United States'
    } : {
      taxIdNoText: 'TIN#',
      taxIdNoPopUpValue: 'Provide the Tax identification Number (TIN) '
    };

  const paymentMethod = (event) => {
    const paymentMethod = event.target.value.toLowerCase();
    if (paymentMethod === 'other') {
      setShowOtherPaymentMethodInput(true);
      props.setFormData({
        ...props.formData,
        paymentMethod: event.target.value,
      });
    } else {
      if (showOtherPaymentMethodInput) {
        toggleOtherPaymentMethod();
      }
      props.setFormData({
        ...props.formData,
        paymentMethod: event.target.value,
      });
    }
  };

  return (
    <div className="margin-responsive fade-in">
      <div>
        <h1 className="header-text">{LABELCONST.SUPPLIER_INFORMATION}</h1>
        <div className="new-line" />
        <span>{LABELCONST.REQUIRED_FIELDS_SUPPLIER_INPUT_TEXT}</span>
        <div className="new-line" />
      </div>

      <div className="width-75">
        <div className={isTaxFieldVisible(stringConstants.IS_MSME, formData.billingCountry.CountryName) ? '' : 'display-none'}>
          <div>
            <Label className="pad-responsive-t">
              {LABELCONST.IS_MSME}
              <span className="dls-red">*</span>
            </Label>
          </div>
          <RadioGroup
            id="isMsme"
            defaultChecked={formData.isMsme}
            value={formData.isMsme}
            onChange={(event) => {
              setFormErrors({
                ...formErrors,
                isMsme: validateField(
                  event.target.value,
                  'required',
                  'Supplier registered under MSME'
                ),
              });
              setFormData({
                ...formData,
                isMsme: event.target.value,
              });
            }}
          >
            <RadioButton id="1" label="Yes" value="Yes" />
            <RadioButton id="2" label="No" value="No" />
          </RadioGroup>
          <p className="dls-red">{formErrors.isMsme}</p>
        </div>

        <div className={isTaxFieldVisible(stringConstants.PAN, formData.billingCountry.CountryName) ? '' : 'display-none'}>
          <div className="pull-down-4">
            <Label className="pad-responsive-t">
              {LABELCONST.PAN}
              <span className="dls-red">*</span>
            </Label>
            <MousePopover
              headingVal={'PAN #'}
              textValue={'Provide the 10 digit alpha-numeric number issued by the Income Tax department.'}
            />
          </div>
          <Input
            id="panNo"
            maxLength={10}
            value={formData.panNo}
            onChange={(event) => {
              setFormData({ ...formData, panNo: event.target.value });
              setFormErrors({
                ...formErrors,
                panNo: validateField(
                  event.target.value,
                  'required',
                  'PAN No'
                ),
              });
            }}
            onBlur={() =>
              setFormErrors({
                ...formErrors,
                panNo: validateField(formData.panNo, 'required', 'PAN No'),
              })
            }
          />
          <p className="dls-red">{formErrors.panNo}</p>
        </div>

        <div className={isTaxFieldVisible(stringConstants.SERVICE_TAX, formData.billingCountry.CountryName) ? '' : 'display-none'}>
          <div className="pull-down-4">
            <Label className="pad-responsive-t">
              {LABELCONST.SERVICE_TAX_NO}
              <span className="dls-red">*</span>
            </Label>
            <MousePopover
              headingVal={'Service Tax #'}
              textValue={'Provide the 15 digit number issued by the Service Tax & Central Excise Department.'}
            />
          </div>
          <Input
            id="serviceTaxNo"
            maxLength={20}
            value={formData.serviceTaxNo}
            onChange={(event) => {
              setFormData({ ...formData, serviceTaxNo: event.target.value });
              setFormErrors({
                ...formErrors,
                serviceTaxNo: validateField(
                  event.target.value,
                  'required',
                  'Service Tax No'
                ),
              });
            }}
            onBlur={() =>
              setFormErrors({
                ...formErrors,
                serviceTaxNo: validateField(formData.serviceTaxNo, 'required', 'Service Tax No'),
              })
            }
          />
          <p className="dls-red">{formErrors.serviceTaxNo}</p>
        </div>



        <div className={isTaxFieldVisible(stringConstants.ABN, formData.billingCountry.CountryName) ? '' : 'display-none'}>
          <div className="pull-down-4">
            <Label className="pad-responsive-t">
              {LABELCONST.ABN}
              <span className="dls-red">*</span>
            </Label>
            <MousePopover
              headingVal={'ABN#'}
              textValue={'Provide the Australian Business Number issued by the Australian Taxation Office'}
            />
          </div>
          <Input
            id="abn"
            maxLength={20}
            value={formData.abn}
            onChange={(event) => {
              setFormData({ ...formData, abn: event.target.value });
              setFormErrors({
                ...formErrors,
                abn: validateField(
                  event.target.value,
                  'required',
                  'ABN#'
                ),
              });
            }}
            onBlur={() =>
              setFormErrors({
                ...formErrors,
                abn: validateField(formData.abn, 'required', 'ABN#'),
              })
            }
          />
          <p className="dls-red">{formErrors.abn}</p>
        </div>

        <div className={isTaxFieldVisible(stringConstants.REGISTERED_STATE, formData.billingCountry.CountryName) ? '' : 'display-none'}>
          <div>
            <Label className="pad-responsive-t">
              {LABELCONST.REGISTERED_STATE}
              <span className="dls-red">*</span>
            </Label>
          </div>
          <Input
            id="registeredState"
            maxLength={50}
            value={formData.registeredState}
            onChange={(event) => {
              setFormData({ ...formData, registeredState: event.target.value });
              setFormErrors({
                ...formErrors,
                registeredState: validateField(
                  event.target.value,
                  'required',
                  'States where supplier has registered for sales & use tax'
                ),
              });
            }}
            onBlur={() =>
              setFormErrors({
                ...formErrors,
                registeredState: validateField(formData.registeredState, 'required', 'Registered State'),
              })
            }
          />
          <p className="dls-red">{formErrors.registeredState}</p>
        </div>

        <div className={isTaxFieldVisible(stringConstants.REGISTRATION_NUMBER, formData.billingCountry.CountryName) ? '' : 'display-none'}>
          <div>
            <Label className="pad-responsive-t">
              {LABELCONST.REGISTERED_STATE_NO}
              <span className="dls-red">*</span>
            </Label>
          </div>
          <Input
            id="registeredStateNo"
            maxLength={50}
            value={formData.registeredStateNo}
            onChange={(event) => {
              setFormData({ ...formData, registeredStateNo: event.target.value });
              setFormErrors({
                ...formErrors,
                registeredStateNo: validateField(
                  event.target.value,
                  'required',
                  'Registration Number for each State'
                ),
              });
            }}
            onBlur={() =>
              setFormErrors({
                ...formErrors,
                registeredStateNo: validateField(formData.registeredStateNo, 'required', 'Registered State No'),
              })
            }
          />
          <p className="dls-red">{formErrors.registeredStateNo}</p>
        </div>

        <div className={isTaxFieldVisible(stringConstants.UEN, formData.billingCountry.CountryName) ? '' : 'display-none'}>
          <div className="pull-down-4">
            <Label className="pad-responsive-t">
              {LABELCONST.UEN}
              <span className="dls-red">*</span>
            </Label>
            <MousePopover
              headingVal={'UEN#'}
              textValue={'Provide the Unique Identity Number'}
            />
          </div>
          <Input
            id="uen"
            maxLength={20}
            value={formData.uen}
            onChange={(event) => {
              setFormData({ ...formData, uen: event.target.value });
              setFormErrors({
                ...formErrors,
                uen: validateField(
                  event.target.value,
                  'required',
                  'UEN#'
                ),
              });
            }}
            onBlur={() =>
              setFormErrors({
                ...formErrors,
                uen: validateField(formData.uen, 'required', 'UEN#'),
              })
            }
          />
          <p className="dls-red">{formErrors.uen}</p>
        </div>

        <div>
          <div className="pull-down-4">
            <Label className="pad-responsive-t">
              {LABELCONST.GST_NO}
              <span className="dls-red">*</span>
            </Label>
            <MousePopover
              headingVal={LABELCONST.GST_NO}
              textValue={LABELCONST.GST_TEXT_INFO}
            />
          </div>
          <Input
            id="gstNo"
            value={formData.gstNo}
            maxLength={20}
            onChange={(event) => {
              setFormData({ ...formData, gstNo: event.target.value });
              setFormErrors({
                ...formErrors,
                gstNo: validateField(
                  event.target.value,
                  'required',
                  'GST No/Tax ID'
                ),
              });
            }}
            onBlur={() =>
              setFormErrors({
                ...formErrors,
                gstNo: validateField(formData.gstNo, 'required', 'GST No/Tax ID'),
              })
            }
          />
          <span>{LABELCONST.GST_TAX_VERBIAGE_INFO}</span>
          <p className="dls-red">{formErrors.gstNo}</p>
        </div>

        <div className={isBillingCountryAndCountryFrance(
            formData.billingCountry.CountryName,
            formData.country.CountryName
          ) ? '' : 'display-none'}
        >
          <Label className="pad-responsive-t">
            {LABELCONST?.SIREN_NUMBER} <span className="dls-red">*</span>
          </Label>
          <Input
            id="sirenNumber"
            maxLength={20}
            value={formData.sirenNumber}
            onChange={(event) => {
              setFormData({ ...formData, sirenNumber: event.target.value });
              setFormErrors({
                ...formErrors,
                sirenNumber: validateField(
                  event.target.value,
                  'dashAlphanumeric',
                  `SIREN Number`
                ),
              });
            }}
            onBlur={() => {
              setFormErrors({
                ...formErrors,
                sirenNumber: validateField(
                  formData.sirenNumber,
                  'dashAlphanumeric',
                  `SIREN Number`
                ),
              });
            }}
          />
          <span>{LABELCONST?.SIREN_VERBIAGE_INFO}</span>
          <p className="dls-red">{formErrors.sirenNumber}</p>
        </div>

        <div className={isBillingCountryAndCountryFrance(
            formData.billingCountry.CountryName,
            formData.country.CountryName
          ) ? '' : 'display-none'}
        >
          <Label className="pad-responsive-t">
            {LABELCONST?.SIRET_NUMBER} <span className="dls-red">*</span>
          </Label>
          <Input
            id="siretNumber"
            value={formData.siretNumber}
            maxLength={20}
            onChange={(event) => {
              setFormData({ ...formData, siretNumber: event.target.value });
              setFormErrors({
                ...formErrors,
                siretNumber: validateField(
                  event.target.value,
                  'dashAlphanumeric',
                  `SIRET Number`
                ),
              });
            }}
            onBlur={() => {
              setFormErrors({
                ...formErrors,
                siretNumber: validateField(
                  formData.siretNumber,
                  'dashAlphanumeric',
                  `SIRET Number`
                ),
              });
            }}
          />
          <span>{LABELCONST?.SIRET_VERBIAGE_INFO}</span>
          <p className="dls-red">{formErrors.siretNumber}</p>
        </div>

        <div className={isTaxFieldVisible(stringConstants.BUSINESS_REG_CERT_NO, formData.billingCountry.CountryName) ? '' : 'display-none'}>
          <div>
            <Label className="pad-responsive-t">
              {LABELCONST.BUSINESS_REG_CERT_NO}
              <span className="dls-red">*</span>
            </Label>
          </div>
          <Input
            id="businessRegCertNo"
            value={formData.businessRegCertNo}
            maxLength={20}
            onChange={(event) => {
              setFormData({ ...formData, businessRegCertNo: event.target.value });
              setFormErrors({
                ...formErrors,
                businessRegCertNo: validateField(
                  event.target.value,
                  'required',
                  'Business Registration Certificate No'
                ),
              });
            }}
            onBlur={() =>
              setFormErrors({
                ...formErrors,
                businessRegCertNo: validateField(formData.businessRegCertNo, 'required', 'Business Registration Certificate No'),
              })
            }
          />
          <p className="dls-red">{formErrors.businessRegCertNo}</p>
        </div>


        <div className={isTaxFieldVisible(stringConstants.TIN, formData.billingCountry.CountryName) ? '' : 'display-none'}>
          <div className="pull-down-4">
            <Label className="pad-responsive-t">
              {taxIdNumber.taxIdNoText}
              <span className="dls-red">*</span>
            </Label>
            <MousePopover
              headingVal={taxIdNumber.taxIdNoText}
              textValue={taxIdNumber.taxIdNoPopUpValue}
            />
          </div>
          <Input
            id="tin"
            maxLength={20}
            value={formData.tin}
            onChange={(event) => {
              setFormData({ ...formData, tin: event.target.value });
              setFormErrors({
                ...formErrors,
                tin: validateField(
                  event.target.value,
                  'required',
                  'TIN#'
                ),
              });
            }}
            onBlur={() =>
              setFormErrors({
                ...formErrors,
                tin: validateField(formData.tin, 'required', 'TIN#'),
              })
            }
          />
          <p className="dls-red">{formErrors.tin}</p>
        </div>
        <Label className="pad-responsive-t">
          {LABELCONST.AUDIT_FIRM} <span className="dls-red">*</span>
        </Label>
        <RadioGroup
          id="isAuditFirm"
          defaultChecked={formData.isAuditFirm}
          value={formData.isAuditFirm}
          onChange={(event) => {
            setFormErrors({
              ...formErrors,
              isAuditFirm: validateField(
                event.target.value,
                'required',
                'Audit Firm'
              ),
            });
            setFormData({
              ...formData,
              isAuditFirm: event.target.value,
            });
          }}
        >
          <RadioButton id="3" label="Yes" value="Yes" />
          <RadioButton id="4" label="No" value="No" />
        </RadioGroup>
        <p className="dls-red">{formErrors.isAuditFirm}</p>
        <Label className="pad-responsive-t">
          {LABELCONST.PAYMENT_METHOD} <span className="dls-red">*</span>
        </Label>
        <Select
          id="paymentMethod"
          className="min-width-100"
          value={formData.paymentMethod}
          onChange={(event) => {
            paymentMethod(event);
            setFormErrors({
              ...props.formErrors,
              paymentMethod: validateField(
                event.target.value,
                'required',
                'Payment Method'
              ),
            });
          }}
          onBlur={() =>
            setFormErrors({
              ...props.formErrors,
              paymentMethod: validateField(
                props.formData.paymentMethod,
                'required',
                'Payment Method'
              ),
            })
          }
        >
          <SelectOption value="" />
          {props.staticData.paymentMethods?.map((field) => (
            <SelectOption key={field} value={field}>
              {field}
            </SelectOption>
          ))}
        </Select>
        <p className="dls-red">{props.formErrors.paymentMethod}</p>
        {(showOtherPaymentMethodInput ||
          (props.formData.paymentMethod === 'Other')) &&
          (
            <Input
              id="otherPaymentMethod"
              maxLength={50}
              value={props.formData.otherPaymentMethod}
              onChange={(event) => {
                setotherPaymentMethod(event.target.value),
                  props.setFormData({
                    ...props.formData,
                    otherPaymentMethod: event.target.value,
                  });
              }}
              className="min-width-50"
              onKeyUp={() =>
                validateInputs(
                  props.page,
                  props.setFormErrors,
                  props.formData,
                  props.isNextClicked
                )
              }
            />
          )}
        {(showOtherPaymentMethodInput || props.formData.paymentMethod === 'Other') && <p className="dls-red">{props.formErrors.otherPaymentMethod}</p>}

        <div className="pull-down-4">
          <Label className="pad-responsive-t">
            {LABELCONST.REMITTANCE_EMAIL_ADDRESS}{' '}
            <span className="dls-red">*</span>
          </Label>
          <MousePopover
            headingVal={LABELCONST.REMITTANCE_EMAIL_ADDRESS}
            textValue={LABELCONST.EMAIL_ADDRESS_PAYMENT_ADVICE}
          />
        </div>
        <Input
          id="remittanceEmailAddress"
          maxLength={100}
          value={formData.remittanceEmailAddress}
          onChange={(event) => {
            setFormData({
              ...formData,
              remittanceEmailAddress: event.target.value,
            });
            setFormErrors({
              ...formErrors,
              remittanceEmailAddress: validateField(
                event.target.value,
                'required',
                'Remittance Email address'
              ),
            });
          }}
          onBlur={() =>
            setFormErrors({
              ...formErrors,
              remittanceEmailAddress: validateField(
                formData.remittanceEmailAddress,
                'email',
                'Remittance'
              ),
            })
          }
        />
        <p className="dls-red">{formErrors.remittanceEmailAddress}</p>
        <div className="pull-down-4">
          <Label className="pad-responsive-t">
            {LABELCONST.PAYMENT_TERMS} <span className="dls-red">*</span>
          </Label>
          <MousePopover
            headingVal={LABELCONST.PAYMENT_TERMS}
            textValue={LABELCONST.PAYMENT_TERMS_VERBIAGE_INFO}
          />
        </div>
        <Select
          id="paymentTerms"
          className="min-width-100"
          value={formData.paymentTerms}
          onChange={(event) => {
            setFormData({
              ...formData,
              paymentTerms: event.target.value,
            });
            setFormErrors({
              ...formErrors,
              paymentTerms: validateField(
                event.target.value,
                'required',
                'Payment Terms'
              ),
            });
          }}
          onBlur={() =>
            setFormErrors({
              ...formErrors,
              paymentTerms: validateField(
                formData.paymentTerms,
                'required',
                'Payment Terms'
              ),
            })
          }
        >
          <SelectOption value="" />
          {props.staticData.paymentTerms?.map((field) => (
            <SelectOption key={field} value={field}>
              {field}
            </SelectOption>
          ))}
        </Select>
        <p className="dls-red">{formErrors.paymentTerms}</p>
        {isPaymentMethodCPCOrBIP(formData?.paymentMethod?.toLowerCase() ?? '') &&
          <>
            <div className="pull-down-4 width-109">
              <Label className="pad-responsive-t">
                {LABELCONST.SERVICE_ESTABLISHMENT}
              </Label>
              <MousePopover
                headingVal="Service Establishment"
                textValue={LABELCONST.SERVICE_ESTABLISHMENT_INFO}
              />
            </div>
            <Input
              id="serviceEstablishment"
              maxlength={10}
              value={formData.serviceEstablishment}
              onChange={(event) => {
                setFormData({
                  ...formData,
                  serviceEstablishment: event.target.value,
                })
                setFormErrors({
                  ...formErrors,
                  serviceEstablishment: validateField(
                    event.target.value,
                    'dashAlphanumeric',
                    `Service Establishment Method`
                  ),
                });
              }
              }
              onBlur={() =>
                setFormErrors({
                  ...formErrors,
                  serviceEstablishment: validateField(
                    formData.serviceEstablishment,
                    'dashAlphanumeric',
                    `Service Establishment Method`
                  ),
                })
              }
            />
            <p className="dls-red">{props.formErrors.serviceEstablishment}</p>
          </>
        }

        <div className={isTaxFieldVisible(stringConstants.NIF, formData.billingCountry.CountryName) ? '' : 'display-none'}>
          <div>
            <Label className="pad-responsive-t">
              {LABELCONST.NIF}
              <span className="dls-red">*</span>
            </Label>
          </div>
          <Input
            id="nif"
            maxLength={50}
            value={formData.nif}
            onChange={(event) => {
              setFormData({ ...formData, nif: event.target.value });
              setFormErrors({
                ...formErrors,
                nif: validateField(
                  event.target.value,
                  'required',
                  'NIF code'
                ),
              });
            }}
            onBlur={() =>
              setFormErrors({
                ...formErrors,
                nif: validateField(formData.abn, 'required', 'NIF code'),
              })
            }
          />
          <p className="dls-red">{formErrors.nif}</p>
        </div>
      </div>
    </div>
  );
};
export default SupplierOtherInfo;
